import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #LIST-ITEM
\*------------------------------------ */
[popover] {
  position: unset;
  inset: unset;
  width: unset;
  height: unset;
  margin: unset;
  border: unset;
  padding: unset;
  color: unset;
  background-color: unset;
  overflow: unset;
}

/**
 * check mark when item is active
 */
.cat-c-check-mark__icon {
  position: relative;
  /**
  * Size of Check Mark
  */
  --cat-icon-height: calc(var(--size-base-unit) * 2);
  --cat-icon-width: calc(var(--size-base-unit) * 2);
}

/**
 * To highlight the searched text in list
 */
.cat-c-list-item__highlighted {
  background-color: var(--cat-color-brand-cat-yellow);
}

:host {
  display: block;
}

:host([aria-selected=true]) {
  display: block;
  background-color: var(--cat-list-item-link-hover-background, var(--cat-theme-color-background-default-hover));
}

/**
 * List item within the list component
 */
.cat-c-list-item {
  list-style: none;
  margin-block-end: var(--cat-list-item-link-margin-block-end, 1px);
}
:host(:last-child) .cat-c-list-item {
  margin-block-end: 0;
}
.cat-c-list-item.cat-is-disabled {
  cursor: not-allowed;
}

.cat-c-list-item--flyout {
  position: relative;
}

.cat-c-list-item-static.cat-c-list-item,
.cat-c-list-item-static.cat-c-list-item[aria-selected=true] {
  background-color: var(--cat-list-item-link-static-background, var(--cat-list-item-link-hover-background, var(--cat-theme-color-background-default)));
  pointer-events: none;
}
.cat-c-list-item-static.cat-c-list-item .cat-c-list-item__link:hover,
.cat-c-list-item-static.cat-c-list-item[aria-selected=true] .cat-c-list-item__link:hover {
  background-color: var(--cat-list-item-link-static-background, var(--cat-list-item-link-hover-background, var(--cat-theme-color-background-default)));
  outline: none;
  pointer-events: none;
}

.cat-c-list-item-static.cat-c-list-item.cat-c-list-item--megamenuflyout,
.cat-c-list-item-static.cat-c-list-item[aria-selected=true].cat-c-list-item--megamenuflyout {
  background: var(--cat-theme-color-background-default);
}

/**
*slotted custom link
*/
.cat-c-list-item__link ::slotted(a) {
  text-decoration: none;
  color: inherit;
  cursor: pointer;
}

/**
 * Link styling for list items
 */
.cat-c-list-item__link {
  font-family: var(--cat-theme-typography-body-font-family);
  font-weight: var(--cat-theme-typography-body-font-weight);
  font-size: var(--cat-theme-typography-body-font-size);
  line-height: var(--cat-theme-typography-body-line-height);
  width: var(--cat-list-item-link-width, calc(100% - calc(var(--size-base-unit) * 0.5)));
  margin-inline: var(--cat-list-item-link-margin-inline-start, calc(var(--size-base-unit) * 0.25)) var(--cat-list-item-link-margin-inline-start, calc(var(--size-base-unit) * 0.25));
  display: flex;
  gap: var(--cat-space-x-small);
  align-items: center;
  justify-content: space-between;
  text-decoration: none;
  border: none;
  padding-block: var(--cat-list-item-link-padding-block-start, var(--cat-space-3x-small)) var(--cat-list-item-link-padding-block-end, var(--cat-space-3x-small));
  padding-inline: var(--cat-list-item-link-padding-inline-start, var(--cat-space-x-small)) var(--cat-list-item-link-padding-inline-end, var(--cat-space-x-small));
  color: var(--cat-list-item-link-font-color, "inherit");
  transition: background-color var(--cat-anim-fade-quick) var(--cat-anim-ease);
  background-color: var(--cat-list-item-background-color, var(--cat-theme-color-background-default));
  cursor: pointer;
  text-align: start;
  min-height: var(--cat-list-item-link-min-height);
  border-radius: var(--cat-list-item-link-border-radius);
  /**
   * Hover & focus state of the list item link
   */
  /**
   * Focus visible state of the list item link
   */
  /**
   * Error styling for list item link
   */
  /**
   * Disabled styling of the list item link
   */
  /**
   * Current styling of the list item link
   */
  /**
   * Active styling of the list item link
   */
  /**
  * when list-item has children of list-items,set bg-color to default black on all states expect current and expanded false .
  **/
  /**
   * Small spacing for the list item link
   */
  /**
   * Large spacing for the list item link
   */
  /**
   * List item with bare dropdown panel
   */
}
.cat-c-list-item__link:hover, .cat-c-list-item[aria-selected=true] .cat-c-list-item__link {
  background-color: var(--cat-list-item-link-hover-background, var(--cat-theme-color-background-default-hover));
}
.cat-c-list-item__link:focus-visible, .cat-c-list-item__link.cat-c-list-item__link-focus-active {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-inset-focus-ring, -4px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-is-error .cat-c-list-item__link {
  color: var(--cat-theme-color-content-utility-error);
}
.cat-is-disabled .cat-c-list-item__link {
  pointer-events: none;
  color: var(--cat-theme-color-content-disabled);
}
.cat-is-current .cat-c-list-item__link {
  background-color: var(--cat-list-item-link-hover-background, var(--cat-theme-color-background-default-hover));
}
.cat-is-active .cat-c-list-item__link {
  background-color: var(--cat-list-item-link-active-background, var(--cat-list-item-link-hover-background, var(--cat-theme-color-background-default-hover)));
}
.cat-is-current.cat-c-list-item-navigation-mobile .cat-c-list-item__link[aria-expanded=true] {
  background-color: var(--cat-list-item-link-hover, var(--cat-list-item-link-hover-background, var(--cat-theme-color-background-default-hover)));
}
.cat-is-current.cat-c-list-item-navigation-mobile .cat-c-list-item__link[aria-expanded=false] {
  background-color: var(--cat-list-item-link-strong-hover, var(--cat-list-item-link-hover-background, var(--cat-theme-color-background-default-hover)));
}
.cat-is-current.cat-c-list-item-navigation-mobile .cat-c-list-item__link:hover {
  background-color: var(--cat-list-item-link-hover-background, var(--cat-theme-color-background-default-hover));
}
.cat-is-active.cat-c-list-item-navigation-mobile .cat-c-list-item__link[aria-expanded=true] {
  background-color: var(--cat-list-item-link-active-background, var(--cat-list-item-link-strong-hover, var(--cat-list-item-link-hover-background, var(--cat-theme-color-background-default-hover))));
}
.cat-is-active.cat-c-list-item-navigation-mobile .cat-c-list-item__link:hover {
  background-color: var(--cat-list-item-link-hover-background, var(--cat-theme-color-background-default-hover));
}
.cat-c-list-item--small .cat-c-list-item__link {
  padding-block: var(--cat-list-item-link-padding-block-start, 0) var(--cat-list-item-link-padding-block-end, 0);
}
.cat-c-list-item--large .cat-c-list-item__link {
  padding-block: var(--cat-list-item-link-padding-block-start, var(--cat-space-small)) var(--cat-list-item-link-padding-block-end, var(--cat-space-small));
}
.cat-c-list-item--dropdown-panel-bare .cat-c-list-item__link {
  width: calc(100% - calc(var(--size-base-unit) * 0.25));
  margin-inline: calc(var(--size-base-unit) * 0.125);
}

/**
  * Cat list within a cat list item
  * 1) Add thin line between nested list in selected item to not bleed together
  */
.cat-c-list-item:not(.cat-c-list-item--flyout, .cat-c-list-item--drawer, .cat-c-list-item--megamenuflyout) ::slotted(cat-list) {
  display: block; /* 1 */
  margin-block-start: var(--cat-list-item-slotted-margin-block-start, 1px); /* 1 */
}

/**
 * List item body
 * 1) Allows the outer container to be flexed to make room for item footer content,
 * or content that is aligned at the end of the item container
 * 2) Set margin for list item inside cat-side-menu-item
 */
.cat-c-list-item__body {
  display: flex;
  max-width: var(--cat-list-item-body-width, 100%);
  gap: var(--cat-space-x-small);
  align-items: center;
  flex: 1;
  margin-inline: var(--cat-side-menu-item-panel-list-item-body-margin-inline-start, 0) var(--cat-side-menu-item-panel-list-item-body-margin-inline-end, 0); /* 2 */ /* 2 */
}
.cat-c-list-item__body .check-icon {
  color: red;
  float: inline-end;
}

/**
 * List item text inside the link
 */
.cat-c-list-item__text,
.cat-c-list-item__text ::slotted(a) {
  margin-inline-end: auto;
  overflow: var(--cat-list-item-link-overflow, hidden);
  text-overflow: ellipsis;
  min-width: var(--cat-list-item-text-min-width, auto);
}

/**
* Added padding to View All for Tab Focus purpose
*/
.cat-c-list-item__text ::slotted(cat-text-link) {
  padding-inline-start: var(--cat-list-item-text-padding, 2px);
}

/**
 * List item icon & after
 * The slots before and after the list item text
 */
.cat-c-list-item__icon,
.cat-c-list-item__after {
  display: flex;
  gap: var(--cat-space-x-small);
  align-items: center;
  --cat-icon-height: calc(var(--size-base-unit) * 2);
  --cat-icon-width: calc(var(--size-base-unit) * 2);
}

/**
 * Styling for subitems container
 */
.cat-c-list-item__items {
  visibility: hidden;
  height: 0;
  overflow: hidden;
  /**
   * Subitems container within active list item
   */
}
.cat-c-list-item.cat-is-active .cat-c-list-item__items {
  visibility: var(--cat-c-list-item-visibility, visible);
  height: auto;
  overflow: visible;
}
.cat-c-list-item--megamenuflyout .cat-c-list-item__items {
  visibility: visible;
  overflow: visible;
}
.cat-c-list-item--flyout .cat-c-list-item__items, .cat-c-list-item--drawer .cat-c-list-item__items, .cat-c-list-item--megamenuflyout .cat-c-list-item__items {
  display: none;
}
.cat-c-list-item--flyout.cat-is-active .cat-c-list-item__items, .cat-c-list-item--drawer.cat-is-active .cat-c-list-item__items {
  display: block;
}
.cat-c-list-item--megamenuflyout.cat-is-active .cat-c-list-item__items {
  display: block;
}

/**
 * Icon that shows that the item has children
 */
.cat-c-list-item__items-icon {
  --cat-icon-height: calc(var(--size-base-unit) * 2);
  --cat-icon-width: calc(var(--size-base-unit) * 2);
  transition: transform var(--cat-anim-fade-quick) var(--cat-anim-ease);
  /**
   * Items icon within active list item
   * 1) Rotate accordion icon -180deg
   */
}
.cat-c-list-item.cat-is-active:not(.cat-c-list-item--flyout, .cat-c-list-item--drawer, .cat-c-list-item--megamenuflyout) .cat-c-list-item__items-icon {
  transform: rotate(-180deg);
}
.cat-c-list-item__items-icon.cat-c-list-item-chevron-right {
  --cat-icon-display: var(--cat-c-list-item-icon-display, block);
}

/**
 * Dropdown panel for flyout menus
 * 2) Used to align baselines of item with first subitem
 */
.cat-c-list-item__dropdown-panel {
  position: var(--cat-list-item__dropdown-panel-position, absolute);
  inset-block-start: var(--cat-list-item__dropdown-panel-inset-block-start, -5px);
  inset-inline-start: 100%; /* 1 */
  min-width: calc(var(--size-base-unit) * 22.5);
  max-width: 100%;
  height: var(--cat-list-item__dropdown-panel-height, auto);
  /**
   * List item dropdown panel within flyout position left
   * 1) Position dropdown to the left of the list item
   */
  /**
   * List item dropdown panel within flyout position bottom
   * 1) Position dropdown below list item
   */
  /**
   * List item dropdown panel within flyout position top
   * 1) Position dropdown above list item
   */
}
.cat-c-list-item--drawer .cat-c-list-item__dropdown-panel {
  display: block;
  inset-block-start: var(--cat-list-item__dropdown-panel-inset-block-start, 0);
  inset-inline-start: 0; /* 1 */
  min-width: 100%;
  height: var(--cat-list-item__dropdown-panel-height, 100%);
  overflow-y: var(--cat-list-drawer-dropdown-panel-overflow, visible);
  --cat-dropdown-panel-height: var(--cat-list-drawer-dropdown-panel-height, 100%);
  --cat-dropdown-panel-body-height: 100%;
  --cat-dropdown-panel-body-position: static;
  --cat-panel-box-shadow: none;
}
.cat-c-list-item--flyout-position-left .cat-c-list-item__dropdown-panel {
  inset-inline-start: 100%;
  inset-inline-end: unset;
}
.cat-c-list-item--flyout-position-bottom .cat-c-list-item__dropdown-panel {
  inset-inline-start: 0;
  inset-block-start: 100%;
}
.cat-c-list-item--flyout-position-top .cat-c-list-item__dropdown-panel {
  inset-inline-start: 0;
  inset-block-start: unset;
  inset-block-end: 100%;
}
.cat-c-list-item__dropdown-panel.cat-c-dropdown-panel-only-flyout {
  inset-inline-start: unset;
  inset-inline-end: unset;
  inset-block-start: unset;
  inset-block-end: unset;
}

.cat-c-list-item:not(.cat-c-list-item--has-slot-before) .cat-c-list-item__icon, .cat-c-list-item:not(.cat-c-list-item--has-slot-after) .cat-c-list-item__after, .cat-c-list-item:not(.cat-c-lis-item--has-items-slot) :is([part=safe-triangle-wrapper], [part=items-wrapper]) {
  display: none;
}
`;
       